import './Page404.css'
import AssetImages from '../../Helper/AssetImages'
import AssetImage from '../../Helper/AssetImage'
import SectionIds from '../../Helper/SectionId'
import { Link } from 'react-router-dom';
import Button from '../../Components/Button/Button'
import ArrowBtn from '../../Components/ArrowBtn/ArrowBtn'

import React from 'react'
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';

export default function Page404() {
    return (
        <SectionWithAnalytics className='section section-404 container-vertical res-gap-16' id={SectionIds.section404}>
            <AssetImage className='image' assetImage={AssetImages.illustration404} />

            <div className='container-horizontal res-gap-32 justify-center'>
                <Link to={`/#${SectionIds.sectionContactMe}`}>
                    <Button
                        name='Contact Me'
                    />
                </Link>
                <Link to={`/#${SectionIds.sectionHome}`}>
                    <ArrowBtn>Back Home</ArrowBtn>
                </Link>
            </div>

        </SectionWithAnalytics>
    )
}

